import React from "react"

export function ChevronIcon(props: any) {
    return (
        <svg
            onClick={props.onClick}
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="27.5"
                y="27.5"
                width="27"
                height="27"
                rx="13.5"
                transform="rotate(-180 27.5 27.5)"
                fill="#EFEFEF"
                stroke="#EBEBEB"
            />
            <path
                d="M13.9661 18C13.77 18 13.5738 17.9146 13.4244 17.7437L8.82609 12.4937C8.52672 12.1519 8.52672 11.5981 8.82609 11.2563C9.12546 10.9146 9.61043 10.9146 9.9098 11.2563L13.9661 15.8891L18.0231 11.257C18.3225 10.9152 18.8075 10.9152 19.1068 11.257C19.4062 11.5988 19.4062 12.1525 19.1068 12.4943L14.5086 17.7443C14.3589 17.9152 14.1625 18 13.9661 18Z"
                fill="#90929E"
            />
        </svg>
    )
}
